var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 0V1.33333H1.6862L0.59375 8.66667H1.96224L2.74089 3.33333H11.7565L12.5586 8.66667H13.9271L12.8034 1.33333H13.9271V0H0.59375Z",
    fill: "#7A7D80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTName);
export default __webpack_public_path__ + "static/media/tName.3e95a88e6f60b60922141411c32e2c56.svg";
export { ForwardRef as ReactComponent };